// extracted by mini-css-extract-plugin
module.exports = {"container":"Top_container__1QtQa","section":"Top_section__2TGOx","title":"Top_title__tLo-G"};